

import Component, {mixins} from "vue-class-component";
import AuthMixin from "../../mixins/auth.mixin";
import {MaterialType} from "shared/entities/material";
import {CreateMaterialRequest, UpdateMaterialRequest} from "shared/api/routes/material";
import {Watch} from "vue-property-decorator";
import {Api} from "shared/api";
import {apiHandler} from "@/services/api-handler";
import FileUpload from "@/components/file-upload.vue";
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";

@Component({
    components: {FileUpload, VueTypeaheadBootstrap}
})
export default class ManageMaterial extends mixins(AuthMixin) {
    type: "New" | "Update" = "New";
    MaterialType = MaterialType;
    material: CreateMaterialRequest = {
        file: "",
        hasQuiz: false,
        order: 0,
        category: "",
        questions: [],
        title: "",
        type: MaterialType.PDF,
    };

    categories: string[] = [];

    @Watch("material.file")
    private onMaterialFileChanged() {
        const extension = this.material.file.substr(this.material.file.lastIndexOf(".") + 1).toLowerCase();
        switch (extension) {
        case "pdf": this.material.type = MaterialType.PDF; break;
        case "mp4": this.material.type = MaterialType.Video; break;
        }
    }

    async mounted() {
        if (this.$route.name === "add-material") {
            this.type = "New";
        } else if (this.$route.name === "edit-material") {
            this.type = "Update";
            this.material = await apiHandler(() => Api.material[this.$route.params.id].Get());
        } else {
            await this.$router.push("/manage/materials");
            return;
        }
        this.categories = await apiHandler(() => Api.material.categories.Get());
    }

    async onSubmit() {
        if (this.type === "New") {
            await apiHandler(() => Api.material.Post(this.material));
        } else {
            await apiHandler(() => Api.material[this.$route.params.id].Patch(this.material as UpdateMaterialRequest));
        }
        alert(`Training Material ${this.type === "New" ? "Added" : "Edited"}`);
        await this.$router.push("/manage/materials");
    }

    insertQuestion() {
        this.material.questions.push({prompt: "", answers: [""], correctAnswer: 0});
    }

    removeQuestion(idx: number) {
        this.material.questions.splice(idx, 1);
    }

    removeAnswer(qIdx: number, aIdx: number) {
        this.material.questions[qIdx].answers.splice(aIdx, 1);
    }
}

